import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, TEXT_ALIGNMENT_OPTIONS, TextAlignmentOptions, Url } from '#const';
import { getIconUrl } from '#utils';

const ContactUs = dynamic(() => import('./ContactUs'));

Builder.registerComponent(ContactUs, {
	name: 'ContactUs',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			defaultValue: '<h1>Contact Us</h1>',
		},
		{
			name: 'headingAlignment',
			friendlyName: 'Heading Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
		},
		{
			name: 'copy',
			friendlyName: 'Copy',
			type: 'richText',
			defaultValue:
				"<p>If you became injured or seriously ill after using a product or service, \
                we can help. Please review our current cases section to see how we are \
                currently helping victims. If you don't see the case you're looking for or \
                have any other questions, please reach out via the form on this page. </p>",
		},
		{
			name: 'copyAlignment',
			friendlyName: 'Copy Alignment',
			type: 'string',
			enum: [...TEXT_ALIGNMENT_OPTIONS],
			defaultValue: TextAlignmentOptions.LEFT,
		},
		{
			name: 'image',
			friendlyName: 'Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
			defaultValue: Url.PLACEHOLDER,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#F9FAFB',
		},
	],
	defaultChildren: [
		{
			'@type': '@builder.io/sdk:Element',
			component: {
				name: 'SingleForm',
				options: {
					showFinePrint: false,
					showLogos: true,
				},
			},
		},
	],
	childRequirements: {
		message: 'Child must be a SingleForm component',
		query: {
			'component.name': { $eq: 'SingleForm' },
		},
	},
	image: getIconUrl(Icon.FORM),
});
